import { useMemo } from "react";
import { useApiConfig } from "common-fe";
import { Configuration, OrganizationMemberApi } from "account-common";

// #2194 -- account-common client for resolving a Cognito sub to a display
// name (the Start Scoring not-assigned message names the currently assigned
// scribe when there is one). Same pattern as scoreadmin-fe's
// apps/scoreadmin-fe/src/api/accountApi.js: token + X-Org-Id wiring via
// common-fe's useApiConfig, base URL from VITE_ACCOUNT_API_BASE_URL. Only the
// member-list endpoint is needed here, not the full OrganizationApi
// scoreadmin-fe also carries (scribe-fe already gets its org LIST from
// account-common's OrganizationApi directly in App.jsx's
// ScribeActiveOrgProvider -- this is the separate member-lookup client).
const ACCOUNT_API_BASE_URL = import.meta.env.VITE_ACCOUNT_API_BASE_URL;

export function useAccountApi() {
  const buildConfig = useApiConfig();
  return useMemo(() => {
    const config = new Configuration(buildConfig(ACCOUNT_API_BASE_URL));
    return { org: new OrganizationMemberApi(config) };
  }, [buildConfig]);
}
